import { loadWidget } from '@sitevision/react';
import React from 'react';
import ReactDOM from 'react-dom';
import BenefitsOverviewSection from './templates/molecules/benefitsoverview-section';

loadWidget('.plf-benefits-overview-area', benefitsOverviewWidget => {
    const action = benefitsOverviewWidget.dataset.action;
    ReactDOM.render(<BenefitsOverviewSection action={action} />, benefitsOverviewWidget);
});
